import {
  React,
  Component,
} from 'imports/CommonImports';

import {
  IconWithTooltip,
  MonthPicker,
} from 'imports/DesignImports';

import {
  TooltipIcon,
  FullCircleIcon,
  EmptyCircleIcon,
  LeftArrow,
  RightArrow,
} from 'imports/IconsImports';

import {
  Paper,
  TextField,
  Checkbox,
  RadioButtonGroup,
  RadioButton,
  IconButton,
  Popover,
} from 'material-ui';

require('react-month-picker-input/dist/react-month-picker-input.css');

const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const styles = {
  largeIcon: {
    width: 60,
    height: 60,
  },
  large: {
    width: 120,
    height: 120,
    padding: 30,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    justifyContent: 'space-around',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1',
    minWidth: '40%'
  },
  formContainer: {
    backgroundColor: '#FBFBFB',
    marginTop: '0.5em',
  },
  contentContainer: {
    padding: '1em',
    flexWrap: 'wrap'
  },
  section: {
    padding: '1em'
  },
  formData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  tooltipIcon: {
    color: '#212F55',
    marginLeft: '0.1em'
  },
  labelTooltipContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  labelSection: {
    flex: '1',
    padding: '1em',
    display: 'flex',
    justifyContent: 'space-around'
  },
  fourSection: {
    flex: '5',
    padding: '1em',
  },
  label: {
    textAlign: 'right',
    fontSize: '0.8em',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  textAreaLabel: {
    textAlign: 'right',
    flex: '1',
    marginTop: '1.5em',
    fontSize: '0.8em',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  divider: {
    marginRight: '5em'
  },
  textAreaContainer:{
    flex: '1'
  },
  textArea: {
    borderRight: '1px solid #E0E0E0',
    borderLeft: '1px solid #E0E0E0',
    borderTop: '1px solid #E0E0E0',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  textField: {
    color: '#212F55',
    fontFamily: 'Lato',
    marginTop: '0.1em',
    width: 'inherit'
  },
  selectField: {
    color: '#212F55',
    fontFamily: 'Lato'
  },
  selectedMenuItem:{
    color: '#EC2024'
  },
  optionContainer:{
    flex: 4,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontStyle: 'italic',
    marginTop: '2em'
  },
  option: {
    display: 'table-cell',
    flex: 1,
    width: '25%'
  },
  fakeOption: {
    display: 'table-cell',
    visibility: 'hidden',
    flex: 1,
    width: '25%'
  }
}


class PostulationFormWithSteps extends Component {

  constructor(props){
    super(props);
    if(props.project){
      this.state = {
        economicImpact: props.project.information.economic_impact,
        solutionType: props.project.options.filter((selection) => {return selection.filter_id === 1}).map((selection) => {return selection.option.name}),
        solutionSuggestions: props.filterData.find((filter) => filter.id === 1).options.map((option) => option.name),
        benefitType: props.project.options.filter((selection) => {return selection.filter_id === 21}).map((selection) => {return selection.option.name}),
        benefitSuggestions: props.filterData.find((filter) => filter.id === 21).options.map((option) => option.name),
        novelty: props.project.options.filter((selection) => {return selection.filter_id === 11}).map((selection) => {return selection.option.name})[0],
        implementationDate: new Date(props.project.information.start_date),
        name: props.project.information.name,
        leaderFirstName: props.project.information.leader_first_name,
        leaderLastName: props.project.information.leader_last_name,
        leaderEmail: props.project.information.leader_email,
        problem: props.project.information.problem,
        solution: props.project.information.solution,
        benefits: props.project.information.benefits,
        objectives: props.project.information.objectives,
        characteristics: props.project.information.characteristics,
        sponsorFirstName: props.project.information.sponsor_first_name,
        sponsorLastName: props.project.information.sponsor_last_name,
        area: props.project.information.area.name,
        yearSelection: (new Date(props.project.information.start_date)).getFullYear(),
        monthSelection: (new Date(props.project.information.start_date)).getMonth(),
        currentYear: (new Date()).getFullYear(),
        currentStep: 0,
        open: false
      }
    }
    else {
      this.state = {
        economicImpact: 1,
        solutionType: [],
        solutionSuggestions: props.filterData.find((filter) => filter.id === 1).options.map((option) => option.name),
        benefitType: [],
        benefitSuggestions: props.filterData.find((filter) => filter.id === 21).options.map((option) => option.name),
        novelty: props.filterData.find((filter) => filter.id === 11).options[0].name,
        implementationDate: null,
        name: '',
        leaderFirstName: '',
        leaderLastName: '',
        leaderEmail: '',
        problem: '',
        solution: '',
        benefits: '',
        objectives: '',
        characteristics: '',
        sponsorFirstName: '',
        sponsorLastName: '',
        area: '',
        yearSelection: null,
        monthSelection: null,
        currentYear: (new Date()).getFullYear(),
        currentStep: 0,
        open: false
      }
    }
  }

  render() {
    var information = (
      <div style={{...styles.row, ...styles.contentContainer}}>
        <div style={styles.row}>
          <div style={{...styles.column, ...styles.labelSection}}>
            <div style={styles.label}>Nombre del proyecto</div>
            <div style={styles.label}>Sponsor</div>
            <div style={styles.label}>Área</div>
            <div style={styles.label}>Fecha de implementación <IconWithTooltip icon={<TooltipIcon style={styles.tooltipIcon}/>} tooltip={<p style={{color:'white'}}>En qué año y mes se comenzó o comenzará a ejecutar el proyecto</p>}/></div>
          </div>
          <div style={{...styles.column, ...styles.section}}>
            <div style={styles.textFieldContainer}>
              <TextField
                style={styles.textField}
                name="Name"
                value={this.state.name}
                onChange={(event) => this.handleTextChange(event, "name")}
                />
            </div>
            <div>
              <TextField
                style={styles.textField}
                name="Sponsor"
                disabled={true}
                value={this.props.data ? this.props.data.manager.first_name + ' ' + this.props.data.manager.last_name : this.state.sponsorFirstName + ' ' + this.state.sponsorLastName}
                onChange={(event) => this.handleTextChange(event, "sponsor")}
                />
            </div>
            <div>
              <TextField
                style={styles.textField}
                name="Area"
                disabled={true}
                value={this.props.data ? this.props.data.area.name : this.state.area}
                onChange={(event) => this.handleTextChange(event, "area")}
                />
            </div>
            <div>
              <TextField
                style={styles.textField}
                name="Date"
                value={this.state.monthSelection!==null && this.state.yearSelection!==null? ((this.state.monthSelection + 1)+"-"+this.state.yearSelection):null}
                onClick={this.handleClick}
              />
              <Popover
                open={this.state.open}
                anchorEl={this.state.anchorEl}
                anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                targetOrigin={{horizontal: 'left', vertical: 'top'}}
                onRequestClose={this.handleRequestClose}
              >
                <MonthPicker
                  onChange={(date)=>{this.handleDateChange(null, date)}}
                  months={["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]}
                />
              </Popover>
            </div>
          </div>
        </div>
        <div style={styles.row}>
          <div style={{...styles.column, ...styles.labelSection}}>
            <div style={styles.label}>Nombre líder</div>
            <div style={styles.label}>Apellidos líder</div>
            <div style={styles.label}>Mail líder</div>
          </div>
          <div style={{...styles.column, ...styles.section}}>
            <div style={styles.textFieldContainer}>
              <TextField
                style={styles.textField}
                name="Leader First Name"
                value={this.state.leaderFirstName}
                onChange={(event) => this.handleTextChange(event, "leaderFirstName")}
                />
            </div>
            <div style={styles.textFieldContainer}>
              <TextField
                style={styles.textField}
                name="Leader Last Name"
                value={this.state.leaderLastName}
                onChange={(event) => this.handleTextChange(event, "leaderLastName")}
                />
            </div>
            <div style={styles.textFieldContainer}>
              <TextField
                style={styles.textField}
                name="Leader Email"
                errorText={this.state.emailError}
                value={this.state.leaderEmail}
                onChange={(event) => this.handleTextChange(event, "leaderEmail")}
                />
            </div>
          </div>
        </div>
      </div>
    );
    var criterias = (
      <div style={{...styles.row, ...styles.contentContainer}}>
        <div style={{...styles.column, ...styles.labelSection}}>
          <div style={styles.label}>Tipo de solución</div>
          <div style={styles.label}>Grado de novedad</div>
          <div style={styles.label}>Tipo de beneficio</div>
        </div>
        <div style={{...styles.column, ...styles.fourSection}}>
          <div style={styles.optionContainer}>
            {Array.from(new Array(4), (x, j) => {
              if(this.state.solutionSuggestions.length > j){
                return(
                  <Checkbox
                  style={styles.option}
                  key={j}
                  label={this.state.solutionSuggestions[j]}
                  onCheck={() => this.handleCheckboxChange('solutionType', this.state.solutionSuggestions[j])}
                  checked={this.state.solutionType.includes(this.state.solutionSuggestions[j])}
                  />
                );
              }
              return (
                <Checkbox
                style={styles.fakeOption}
                key={j}
                label="Fake checkbox"
                />
              )
              })
            }
          </div>
          <div>
            <RadioButtonGroup style={styles.optionContainer} name="Grado de novedad" defaultSelected={this.state.novelty} onChange={this.handleSelectChange}>
              {this.props.filterData.find(filter => filter.id === 11).options.map((option) => {
                return (
                  <RadioButton
                    key={option.id}
                    style={styles.option}
                    label={option.name}
                    value={option.name}
                />)
              })}
              <RadioButton
                style={styles.fakeOption}
              />

            </RadioButtonGroup>

          </div>
          <div style={styles.optionContainer}>
            {Array.from(new Array(4), (x, j) => {
              if(this.state.benefitSuggestions.length > j){
                return(
                  <Checkbox
                  style={styles.option}
                  key={j}
                  label={this.state.benefitSuggestions[j]}
                  onCheck={() => this.handleCheckboxChange('benefitType', this.state.benefitSuggestions[j])}
                  checked={this.state.benefitType.includes(this.state.benefitSuggestions[j])}
                  />
                );
              }
              return (
                <Checkbox
                style={styles.fakeOption}
                key={j}
                label="Fake checkbox"
                />
              )
              })
            }
          </div>
        </div>
      </div>
    );
    var solution = (
      <div style={{...styles.row, ...styles.contentContainer}}>
          <div style={{...styles.column, ...styles.labelSection}}>
            <div style={styles.textAreaLabel}><b>Problema u oportunidad</b><br/><br/><i>Describa la necesidad, problema u oportunidad que da origen al proyecto.</i></div>
            <div style={styles.textAreaLabel}><b>Solución</b><br/><br/><i>Explique de que manera se resolvió el problema o aprovechó la oportunidad detectada.</i></div>
            <div style={styles.textAreaLabel}><b>Objetivos</b><br/><br/><i>Describa los principales objetivos del proyecto.</i></div>
            <div style={styles.textAreaLabel}><b>Principales Caracteristicas</b><br/><br/><i>Detalle las principales caracteristicas o atributos que hacen al proyecto único.</i></div>
            <div style={styles.textAreaLabel}><b>Beneficios</b><br/><br/><i>Describa todos los beneficios que genera el proyecto: económico, sociales, ambientales, entre otros.</i></div>
          </div>
          <div style={{...styles.column, ...styles.fourSection}}>
            <div>
              <TextField
                name="Problem"
                textareaStyle={styles.textArea}
                multiLine={true}
                rows={4}
                rowsMax={4}
                fullWidth={true}
                value={this.state.problem}
                onChange={(event) => this.handleTextChange(event, "problem")}
                />
            </div>
            <div>
              <TextField
                name="Solution"
                textareaStyle={styles.textArea}
                multiLine={true}
                rows={4}
                rowsMax={4}
                fullWidth={true}
                value={this.state.solution}
                onChange={(event) => this.handleTextChange(event, "solution")}
                />
            </div>
            <div>
              <TextField
                name="Objetives"
                textareaStyle={styles.textArea}
                multiLine={true}
                rows={4}
                rowsMax={4}
                fullWidth={true}
                value={this.state.objectives}
                onChange={(event) => this.handleTextChange(event, "objectives")}
                />
            </div>
            <div>
              <TextField
                name="Characteristics"
                textareaStyle={styles.textArea}
                multiLine={true}
                rows={4}
                rowsMax={4}
                fullWidth={true}
                value={this.state.characteristics}
                onChange={(event) => this.handleTextChange(event, "characteristics")}
                />
            </div>
            <div>
              <TextField
                name="Benefits"
                textareaStyle={styles.textArea}
                multiLine={true}
                rows={4}
                rowsMax={4}
                fullWidth={true}
                value={this.state.benefits}
                onChange={(event) => this.handleTextChange(event, "benefits")}
                />
            </div>
          </div>
      </div>
    );
    return (
      <Paper zDepth={1} style={{...styles.column, ...styles.formContainer}}>
        {this.showCarousel(information, criterias, solution)}
      </Paper>
    );
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  showCarousel(content0, content1, content2){
    var navigationBar = (
      <div style={{display:'flex', justifyContent: 'center', alignItems:'center'}}>
        <IconButton tooltip="Anterior" iconStyle={styles.largeIcon} style={styles.large} disabled={this.state.currentStep === 0} onClick={()=>this.state.currentStep > 0 ? this.setState((prevState)=>{return {currentStep: prevState.currentStep - 1}}):null}>
          <LeftArrow />
        </IconButton>
        <IconButton tooltip="Información general" onClick={()=>this.setState({currentStep:0})}>
          {this.state.currentStep === 0 ? <FullCircleIcon /> : <EmptyCircleIcon />}
        </IconButton>
        <IconButton tooltip="Caracterización del proyecto" onClick={()=>this.setState({currentStep:1})}>
          {this.state.currentStep === 1 ? <FullCircleIcon /> : <EmptyCircleIcon />}
        </IconButton>
        <IconButton tooltip="Detalle de la solución" onClick={()=>this.setState({currentStep:2})}>
          {this.state.currentStep === 2 ? <FullCircleIcon /> : <EmptyCircleIcon />}
        </IconButton>
        <IconButton tooltip="Siguiente" iconStyle={styles.largeIcon} style={styles.large} disabled={this.state.currentStep === 2} onClick={()=>this.state.currentStep < 2 ? this.setState((prevState)=>{return {currentStep: prevState.currentStep + 1}}):null}>
           <RightArrow />
        </IconButton>
      </div>
    );

    let title = (num) => {
      if(!this.props.project)
        return(
          <div style={{paddingLeft:'20px'}}>
            <h3><b>FORMULARIO DE POSTULACIÓN ({num}/3)</b></h3>
            <p>Completa este formulario con la información de tu proyecto</p>
          </div>)
      else
        return(
          <div style={{paddingLeft:'20px'}}>
            <h3><b>{this.props.project.information.name}</b></h3>
          </div>
        )
    };

    if(this.state.currentStep===0){
      return(<div>{title(1)}{content0}{navigationBar}</div>);
    }
    if(this.state.currentStep===1){
      return(<div>{title(2)}{content1}{navigationBar}</div>);
    }
    if(this.state.currentStep===2){
      return(<div>{title(3)}{content2}{navigationBar}</div>);
    }
  }

  handleSelectChange = (event, value) => {
    if(this.props.handleSelectChange)
      this.props.handleSelectChange(event, value);
    this.setState({novelty: value})
  }

  handleDateChange = (event, date) => {
    if(this.props.handleDateChange){
      this.props.handleDateChange(event, new Date(date))
    }
    this.setState({implementationDate: new Date(date), yearSelection: (new Date(date)).getFullYear(), monthSelection: (new Date(date)).getMonth()})
  }

  handleTextChange = (event, type) => {
    if(this.props.handleTextChange)
      this.props.handleTextChange(event, type)
    this.setState({[type]: event.target.value})
    if(type === 'leaderEmail')
      !re.test(event.target.value.toLowerCase()) ? this.setState({emailError: 'Debes ingresar un email válido'}) : this.setState({emailError: ''})
  }

  handleCheckboxChange = (type, option) => {
    if(this.props.handleCheckboxChange)
      this.props.handleCheckboxChange(type, option);
    var index = this.state[type].indexOf(option);
    if(index === -1){
      this.setState({[type]: [...this.state[type], option]})
    }
    else {
      this.setState((prevState) => ({
        [type]: prevState[type].filter((_,i) => i !== index)
      }));
    }
  }
}

export default PostulationFormWithSteps;



// WEBPACK FOOTER //
// ./src/components/postulation/PostulationFormWithSteps.js